import React, { createContext } from "react";

export const themeCtx = createContext({
  currentTheme: false,
});

export const { Provider } = themeCtx;
